import { React, useState } from "react";
import { BsPlus, BsCartFill, BsFillHeartFill, BsBellFill, BsXLg, BsDash} from "react-icons/bs";
import { Link, useNavigate, useLocation  } from "react-router-dom";
import {alert, confirm} from "../components/MegConfirmAlert";
import Star from "../components/Star";
import { useAxios } from "../services/useAxios";
import { useTranslation } from 'react-i18next';
import ProdList from "../components/ProdList";

export default function Product1 (props){
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();  
    const [isOpen, setOpen] = useState(false);
    const [heart, setHeart] = useState(props.obj && props.obj.likeAt && props.obj.likeAt === 'Y');
    const handleHeart = async () => {
        const userData = localStorage.getItem("user");
        if (userData === null) {
            ConfirmPick();
            return;
        }else{
            const response = await request.post("/app/wishlist/procMyWishListAPI", {
                likeAt : heart?"N":"Y",
                goodsSn : props.obj.goodsSn,
                likeSn : props.obj.likeSn,
            });
            if(response.data.resultCode === 200){
                console.log(response.data)
                setHeart(!heart);
            }
        }
        
    }

    
    
    const [request] = useAxios();
    
    const ConfirmAlrm = async () => {
        const userData = localStorage.getItem("user");
        if (userData === null) {            
            navigate('/LogIn', {
                state: { from: location },
            })            
        }
        const result = await confirm('상품이 입고되면 알림톡으로 알려드립니다.\n재입고 알림을 받으시겠습니까?', {okText : '재입고 신청' , cancelText :t(`Message.common_no`)});
        if(result){
            alert(t(`Message.goods_fetch_restocking_req_sucss`), {okButtonStyle : 'secondary'}, {okText : t(`Message.common_ok`)});    
        }
    }

    const fn_clickOrder = () => {        
        setOpen(true);
    }

    const fn_removeRecent = (obj) => {
        let recentGoods = localStorage.getItem("recentGoods")?JSON.parse(localStorage.getItem("recentGoods")):[];
        const idx = recentGoods.findIndex(function(item) {return item.goodsSn === obj.goodsSn});            
        if (idx > -1)  {
            recentGoods.splice(idx, 1);
        }    
        localStorage.setItem("recentGoods", JSON.stringify(recentGoods));

        props.setRecentGoods(localStorage.getItem("recentGoods")?JSON.parse(localStorage.getItem("recentGoods")):[])
    }
    
 

    const ConfirmPick = async () => {
        const result = await confirm(t(`Message.common_login_page_msg1`) + t(`Message.common_login_page_msg2`), {okText : t(`Message.common_yes`) , cancelText :t(`Message.common_no`)});
        if(result){
            navigate('/LogIn', {
                state: { from: location },
              })
        }
    }

    if (props.type==='type1') {
        return(
            <div>
                <div className="prodType1">
                    <Link to={"/ProductDetail/"+props.obj.goodsSn}>
                    <div className="imgWr">
                        <img src={props.img} alt="제품사진"/>
                    </div>
                    </Link>
                    <ul className="contWr">                       
                        <li>
                            <p className="prodName">{props.prodName}</p>
                            <p className="disprice">{props.disprice}</p>
                        </li>                       
                        <li className="test">
                            <button className="btnX" onClick={(e)=>fn_removeRecent(props.obj)}>
                                
                            </button>
                            
                        </li>
                    </ul>
                </div>                                
            </div>
        );
    } else if (props.type==='type2') {
        return(
            <div>
                <Link to={"/ProductDetail/"+props.obj.goodsSn} className="prodType2">
                    <div className="imgWr">
                        <div className="shWr">
                            
                            { props.obj &&  (props.obj.soldoutAt === 'Y'  || props.obj.sleQy <= 0 )?
                                <>
                                <button 
                                    className="bellBtn" 
                                    onClick={(e) => {
                                        e.preventDefault(); 
                                        e.stopPropagation();
                                        ConfirmAlrm();                                        
                                    }}>
                                    <BsBellFill className="active"/>
                                </button>
                                </>
                                :null
                            }
                            
                            { props.heart &&
                                <button 
                                    className="pickBtn" 
                                    onClick={(e) => {
                                        e.preventDefault(); 
                                        e.stopPropagation(); 
                                        handleHeart();
                                    }}>
                                    { heart ? (<BsFillHeartFill className="active" />) : (<BsFillHeartFill />) }
                                </button>
                            }
                        </div>
                        
                        { props.obj &&  (props.obj.soldoutAt === 'Y'  || props.obj.sleQy <= 0 )?
                            <>
                            <div className="soldOut">
                                <p>Sold Out</p>
                            </div> 
                            </>
                            :null
                        }
                        <img src={props.img} alt="제품사진"/>
                    </div>
                    <div className="contWr">
                        <p className="prodName">{props.prodName}</p>
                        <div className="dfcsG8">
                            <p className="cost">{props.cost}</p>
                            <p className="percent">{props.percent}%</p>
                            <p className="disprice">{props.disprice}</p>
                        </div>
                        <div className="dfsb">
                            <Star type="star1" obj={props.obj} />
                            <div>
                                {props.cart &&
                                    <button
                                        className="openCartModal" 
                                        onClick={(e) => {
                                            e.preventDefault(); 
                                            e.stopPropagation(); 
                                            fn_clickOrder();
                                        }}
                                    >
                                        <BsPlus />
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </Link>
                <ProdList id={props.obj.goodsSn} prodOpen={isOpen} setProdOpen={setOpen}></ProdList>
            </div>
        );
    } else if(props.type==='type3')  {
        return (
            <div>
                <Link to="" className="prodType3">
                    <div className="imgWr">
                        <img src={props.img} alt="d" />
                    </div>
                    <div className="infoWr">
                        <p className="prodName">{props.prodName}</p>
                        <div className="dfcsG6">
                            <p className="cost">{props.cost}</p>
                            <p className="disprice">{props.disprice}</p>
                        </div>
                    </div>
                </Link>
            </div>
        )   
    }
};